import userService from "../../../services/user.service";

async function getAllPermissions() {
  try {
    const payload = {
      filter: {
        textSearch: "",
        permissionGroup: [0],
      },
      pageNumber: -1,
      pageSize: 0,
    };
    const response = await userService.getAllPermissions(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to fetch permissions."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching permissions:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}
async function getAllPermissionsGroup({
  pageNumber = -1,
  pageSize = 0,
  searchQuery = "",
}) {
  try {
    const response = await userService.getAllPermissionsGroup(
      pageNumber,
      pageSize,
      searchQuery
    );

    if (response.data && response.data.status) {
      const reduced = response.data.result.map((group) => ({
        id: group.id,
        name: group.name,
        description: group.description,
        active: group.active,
      }));

      return JSON.stringify(reduced);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to fetch permission groups."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching permission groups:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function addPermissionGroup({
  name,
  isActive,
  description,
  permissionIds,
}) {
  try {
    const payload = { name, active: isActive, description, permissionIds };
    const response = await userService.addPermission(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to add permission group."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error adding permission group:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}
async function updatePermissionGroup({
  id,
  name,
  isActive,
  description,
  permissionIds,
}) {
  try {
    const payload = {
      name,
      active: isActive,
      description,
      id,
      permissionIds,
    };
    const response = await userService.updatePermission(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) ||
        "Failed to update permission group."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error updating permission group:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

export default {
  getAllPermissions,
  getAllPermissionsGroup,
  addPermissionGroup,
  updatePermissionGroup,
  permissionGroupTools: [
    {
      type: "function",
      function: {
        name: "getAllPermissions",
        description:
          "Fetch all permissions from the database. Dont skip any data display all data.",
        parameters: {
          type: "object",
          properties: {},
        },
      },
    },
    {
      type: "function",
      function: {
        name: "getAllPermissionsGroup",
        description:
          "Fetch all permission groups from the database. Dont skip any data display all data.",
        parameters: {
          type: "object",
          properties: {
            pageNumber: {
              type: "integer",
              description:
                "Page number for pagination by default it is -1 for fetching all permission groups",
            },
            pageSize: {
              type: "integer",
              description:
                "Number of subtasks per page  by default it is 0 for fetching all permission groups",
            },
            searchQuery: {
              type: "string",
              description:
                "Search query for filtering. You can search permission groups by some keyword.  by default it is empty string for fetching all permission groups",
            },
          },
        },
      },
    },
    {
      type: "function",
      function: {
        name: "addPermissionGroup",
        description: `Add a new permission group to the system. 
          Before calling this function, you MUST first call getAllPermissions to get available permissions. 
          After fetching permissions, present all permissions (must not skip any permission) to the user in a multiselect field and also all the parameters in the fields, so they can choose permission IDs, name, description and is_active.`,
        parameters: {
          type: "object",
          properties: {
            name: {
              type: "string",
              description: "The name of the permission group.",
            },
            isActive: {
              type: "boolean",
              description: "Whether the permission group is active.",
            },
            description: {
              type: "string",
              description: "A brief description of the permission group.",
            },
            permissionIds: {
              type: "array",
              items: {
                type: "integer",
              },
              description:
                "This will be a multiselect field. An array of permission IDs associated with this group. You can use the getAllPermissions function to return all the permissionss so that the user will select the permissions to give you permissions ids.",
            },
          },
          required: ["name", "isActive", "description", "permissionIds"],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "updatePermissionGroup",
        description: "Update an existing permission group.",
        parameters: {
          type: "object",
          properties: {
            id: {
              type: "integer",
              description:
                "The unique ID of the permission group to be updated.",
            },
            name: {
              type: "string",
              description: "The updated name of the permission group.",
            },
            isActive: {
              type: "boolean",
              description: "Whether the permission group is active.",
            },
            description: {
              type: "string",
              description: "A brief description of the permission group.",
            },
            permissionIds: {
              type: "array",
              items: {
                type: "integer",
              },
              description:
                "The updated array of permission IDs associated with this group. You can use the getAllPermissions function to return all the permissionss so that the user will select the permissions to give you permissions ids. This will be a multiselect field",
            },
          },
          required: ["id"],
        },
      },
    },
  ],
};
